import type { EstimationModelResponse } from '@/api/schema/data-contracts';
import { sortCostTypes, sortResourceTypes } from '@/utils/sorting';

import type {
  CostEstimationItemsFormModelRow,
  CostEstimationItemsTableRecord,
  EstimationItemsFormModelRow,
  ResourceEstimationItemsTableRecord,
} from '../model';

export const mapFromResourceEstimationItemsTableRecord = (
  estimationItem: ResourceEstimationItemsTableRecord,
  estimationMethodologyId: string,
  estimationModel: EstimationModelResponse,
): EstimationItemsFormModelRow => {
  const estimationItemResources = estimationItem.resources;
  const formModelResources = estimationItemResources
    ? sortResourceTypes(estimationModel.resourceTypes, estimationModel.resourceTypeGroups).map(
        (resourceType) => ({
          resourceTypeId: resourceType.id,
          value:
            estimationItemResources.find((resource) => resource.resourceTypeId === resourceType.id)
              ?.value ?? null,
        }),
      )
    : undefined;
  return {
    id: estimationItem.id,
    name: estimationItem.name,
    description: estimationItem.description ?? null,
    isIncluded: !estimationItem.isOmitted,
    omitReason: estimationItem.omitReason ?? null,
    methodologyId: estimationItem.hasEstimationModelItemParameters
      ? null
      : (estimationItem.methodology?.id ?? estimationMethodologyId),
    parentId: estimationItem.parentId ?? null,
    groupId: estimationItem.estimationModelGroupId,
    phaseLeadId: estimationItem.phaseLeadId ?? null,
    parameters: estimationItem.params.map((parameter) => ({
      parameterName: parameter.parameterName,
      value: parameter.value ?? null,
    })),
    resources: formModelResources,
    shouldDelete: false,
  };
};

export const mapFromCostEstimationItemsTableRecord = (
  estimationItem: CostEstimationItemsTableRecord,
  estimationModel: EstimationModelResponse,
): CostEstimationItemsFormModelRow => {
  const estimationItemCosts = estimationItem.estimationItemCosts;
  const formModelItemCosts = estimationItemCosts
    ? sortCostTypes(estimationModel.costTypes, estimationModel.costTypeGroups).map((costType) => ({
        costTypeId: costType.id,
        price:
          estimationItemCosts.find((itemCost) => itemCost.costTypeId === costType.id)?.price ??
          null,
      }))
    : undefined;
  return {
    id: estimationItem.id,
    name: estimationItem.name,
    description: estimationItem.description ?? null,
    isIncluded: !estimationItem.isOmitted,
    omitReason: estimationItem.omitReason ?? null,
    parentId: estimationItem.parentId ?? null,
    groupId: estimationItem.estimationModelGroupId,
    estimationItemCosts: formModelItemCosts,
    shouldDelete: false,
  };
};
